import React, { forwardRef } from 'react';

const LoginInput = forwardRef((props, ref) => (
  <input ref={ref} className="Login-input" {...props} />
));

export default LoginInput;